import { map } from 'lodash'
import { error } from '@/utils/alert'
import bus from '@/utils/eventBus'

export default {
  doCancelAll () {
    const ids = map(this.schedules, schedule => {
      return schedule.id
    })

    this.$resource.put(ids.toString() + '/cancel')
      .then(({data}) => {
        bus.$emit('is-canceled', {show: true})
        this.$emit('close', data)
      })
      .catch(() => {
        error('Ocorreu um erro no cancelamento')
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/components/cancel/resources/methods.js